import {
    LEN_HIOS_PLAN_ID,
    LEN_HIOS_PLAN_ID_WITH_VARIANT,
    PATTERN_HIOS_PLAN_NUM,
    PATTERN_HIOS_PLAN_NUM_WITH_VARIANT,
    PLAN_INITIAL_INDEX,
} from './constant';
import { FILE_TYPE, XML_TYPE_FILE } from '../../constants/common/fileTypes';
import { STATUS_CODE } from '../../constants/common/apiResponse';
import { showModal } from '../../actions/common/actionCreators';
import { commonModalTypes as MODAL_TYPES } from '../../constants/common/modals/commonModalTypes';


export const hasValidPattern = (value: string | null, pattern: RegExp) => {
    return value && pattern && pattern.test(value);
};

export const validateSupportDocument = (originalDocumentName: string, hiosIssuerIdWithState: string) => {
    let hasValidDocument = false;
    let hasDocumentWithPlanId = false;
    let issuerPlanNumber: string | null = null;

    if (LEN_HIOS_PLAN_ID_WITH_VARIANT < originalDocumentName.length) {
        issuerPlanNumber = originalDocumentName.substring(PLAN_INITIAL_INDEX, LEN_HIOS_PLAN_ID_WITH_VARIANT);

        // Validate Support Document Name with HIOS Plan ID with variant.
        if (hasValidPattern(issuerPlanNumber, PATTERN_HIOS_PLAN_NUM_WITH_VARIANT)) {
            hasDocumentWithPlanId = true;
        } else {
            issuerPlanNumber = originalDocumentName.substring(PLAN_INITIAL_INDEX, LEN_HIOS_PLAN_ID);

            // Validate Support Document Name with HIOS Plan ID without variant.
            if (hasValidPattern(issuerPlanNumber, PATTERN_HIOS_PLAN_NUM)) {
                hasDocumentWithPlanId = true;
            }
        }

        // Validate Support Document Name start with Selected Issuer ID and State Code
        if (hasDocumentWithPlanId && !issuerPlanNumber?.startsWith(hiosIssuerIdWithState)) {
            hasDocumentWithPlanId = false;
        }

        // Support Document is start with HIOS Plan ID
        if (hasDocumentWithPlanId) {
            const documentNameToUpperCase = originalDocumentName.toUpperCase();
            const sbcFile = `${issuerPlanNumber}_SBC.PDF`;
            const eocFile = `${issuerPlanNumber}_EOC.PDF`;
            const brochureFile = `${issuerPlanNumber}_BROCHURE.PDF`;

            // SBC document check, EOC document check, BROCHURE document check
            if (
                documentNameToUpperCase === sbcFile ||
                documentNameToUpperCase === eocFile ||
                documentNameToUpperCase === brochureFile
            ) {
                hasValidDocument = true;
            }
        }
    }
    return hasValidDocument;
};

export const hasValidLoadDrugFile = (file: File, fileTypeVal: string) => {
    let hasValid = false;

    if (file) {
        if (fileTypeVal === FILE_TYPE.XML && file.type === XML_TYPE_FILE) {
            hasValid = true;
        } else if (fileTypeVal === FILE_TYPE.JSON) {
            const regexJsonFile = new RegExp('.json$', 'i');
            hasValid = regexJsonFile.test(file.name);
        }
    }
    return hasValid;
};

export const loadDrugsSteps = () => {
    return [
        'admin.loadDrugs.sideBar.content1',
        'admin.loadDrugs.sideBar.content2',
        'admin.loadDrugs.sideBar.content3',
        'admin.loadDrugs.sideBar.content4',
        'admin.loadDrugs.sideBar.content5',
    ];
};

export const showAdminPlanDrugModal = (dispatch, status: STATUS_CODE, modalBodyContent, modalHeaderId) => {
    dispatch(
        showModal({
            modalType: MODAL_TYPES.ADMIN_PLANS_DRUGS_COMMON_MODAL,
            modalData: {
                status,
                modalBodyContent,
                modalHeaderId
            }
        })
    );
};
